import React, {useState} from 'react';
import i18n       from './../../../i18n';
import FormSelect from "./../../Form/FormSelect";
import Query      from "react-apollo/Query";
import contacts   from './ContactLink.query'

class ContactLink extends React.Component {

    constructor(props) {
        super(props);
    }

    prefillFormFields(entity) {
        if(entity) {
            if(!this.props.hasOwnAddress){
                this.props.changeAddress(entity);
            } else {
                this.props.changeAddress(this.props.values);
            }
        } else {
            this.props.changeAddress(this.props.values);
        }
    }

    render(){
        return <Query query={ contacts.query() } onCompleted={e => {
            let data = e.contacts.data;
            let contact = data.filter(
                contact => contact.id === String( this.props.parentId || this.props.values.parent_id )
            );
            contact[0] && this.prefillFormFields(contact[0]);
        }}>
            { contacts.onResponse(this.renderFormSelect.bind(this)) }
        </Query>
    }

    preselect(options, id) {
        return options.filter((option) => option.value === id)[0];
    }

    renderFormSelect(options, loading)
    {
        const {
                  values, touched, errors, handleChange, handleBlur, handleSubmit, contactType, setFieldValue, formUrl,
                  isEdit, isCreateSelf
              } = this.props;

        // TODO avoid re-calling query (onChange -> re-renders -> calls graph-query again)

        return (
            <FormSelect
                type="text"
                name="contact_link"
                label={i18n.get('contacts.company_link')}
                placeholder={loading ? `${i18n.get('default.please_wait')}...` : i18n.get('contacts.related_company')}
                onChange={option => {
                    setFieldValue('parent_id', option.value || null);
                    //this.prefillFormFields(option.entity ? option.entity : null );
                }}
                onBlur={handleBlur}
                value={values.parent_id}
                error={errors.parent_id}
                touched={touched.parent_id}
                options={options}
            />
        )
    }

}

export default ContactLink;
